export const shopViews = {
  purchases: 'purchases',
  favorites: 'favorites',
  basket: 'basket',
};
